import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {isNullOrUndefined} from 'util';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import {DvDialog} from '../../../core/directive/dv-dialog/dv-dialog';
import AnlaufstelleRS from '../../../core/service/AnlaufstelleRS.rest';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import RoleUtilService from '../../../core/service/RoleUtilService';
import SchadenfallModelManager from '../../../core/service/SchadenfallModelManager';
import {eigentumsverhaeltnisPrefix, getTSEigentumsverhaeltnisValuesSchadenfall, TSEigentumsverhaeltnis} from '../../../models/enums/TSEigentumsverhaeltnis';
import {TSErfassungsArt} from '../../../models/enums/TSErfassungsArt';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import TSAnlaufstelle from '../../../models/TSAnlaufstelle';
import TSGesuchsteller from '../../../models/TSGesuchsteller';
import TSSchadenfall from '../../../models/TSSchadenfall';
import TSUser from '../../../models/TSUser';
import AnlaufstelleUtil from '../../../utils/AnlaufstelleUtil';
import DVBernUtil from '../../../utils/DVBernUtil';
import AbstractModelManagerController from '../abstractModelManagerController';

declare let require: any;
declare let angular: any;

import IFormController = angular.IFormController;
import IQService = angular.IQService;
import IScope = angular.IScope;
import ITranslateService = angular.translate.ITranslateService;

let template = require('./gesuchErstellenView.html');
let berechnungsTemplate = require('../../../core/dialog/berechnungsDetail.html');

export class GesuchErstellenViewComponentConfig implements IComponentOptions {
    transclude: boolean = false;
    template: string = template;
    controller: any = GesuchErstellenViewController;
    controllerAs: string = 'vm';
    bindings: any = {
        schadenfall: '<',
    };
}

export class GesuchErstellenViewController extends AbstractModelManagerController<TSSchadenfall> {
    static $inject = [
        'DVBernUtil', 'SchadenfallModelManager', '$q', '$scope', '$state', 'DvDialog',
        'RoleUtilService', 'AuthServiceRS', 'BenutzerRS', 'AnlaufstelleRS', '$translate',
    ];
    private schadenfall: TSSchadenfall; //do not change
    form: IFormController;
    currentYear: number = new Date().getFullYear();
    possibleAnlaufstellen: Array<TSAnlaufstelle> = [];
    displayAnlaufstellenSelect: boolean = true;

    /* @ngInject */
    constructor(private dvBernUtil: DVBernUtil, schadenfallModelManager: SchadenfallModelManager,
                private $q: IQService, $scope: IScope, private $state: IStateService, private dvDialog: DvDialog,
                private roleUtilService: RoleUtilService, private authServiceRS: AuthServiceRS,
                private benutzerRS: BenutzerRS, private anlaufstelleRS: AnlaufstelleRS, private $translate: ITranslateService,
    ) {
        super(schadenfallModelManager, $scope, $state.current.name);
    }

    $onInit() {
        super.$onInit();
        this.initialModel = angular.copy(this.schadenfall);
        this.model = angular.copy(this.schadenfall);
        if (!this.model.zweitperson) {
            this.model.zweitperson = new TSGesuchsteller(true);
        }
        this.model.zweitperson.isZweitperson = true;

        this.changedEigentumsverhaeltinis();

        this.loadAvailableAnlaufstellen();

    }

    public loadAvailableAnlaufstellen(): void {
        let benutzer: TSUser | undefined = this.authServiceRS.getPrincipal();
        if (benutzer && benutzer.id) {
            if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAdministratorRoles())) {
                //admin hat alle zur auswahl
                this.anlaufstelleRS.getAllAnlaufstellen().then((response: Array<TSAnlaufstelle>) => {
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.concat(response);
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.filter(AnlaufstelleUtil.isNotImportiert);
                    this.displayAnlaufstellenSelect = this.model.anlaufstelle === undefined;
                });
            } else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getFondssuisseRoles()) &&
                (this.model.status === TSSchadenfallStatus.NEU_PAPIER_FS)) {
                //auch FS Sachbearbeiter darf im richtigen Zustand anlaufstelle zuweisen
                this.anlaufstelleRS.getAllAnlaufstellen().then((response: Array<TSAnlaufstelle>) => {
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.concat(response);
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.filter(AnlaufstelleUtil.isNotImportiert);
                    this.displayAnlaufstellenSelect = this.model.anlaufstelle === undefined;
                });
            } else if (this.authServiceRS.isOneOfRoles(this.roleUtilService.getAnlaufstelleRoles())) {
                this.benutzerRS.getAnlaufstellenForSachbearbeiter(benutzer.id).then((response: Array<TSAnlaufstelle>) => {
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.concat(response);
                    this.possibleAnlaufstellen = this.possibleAnlaufstellen.filter(AnlaufstelleUtil.isNotImportiert);
                    if (this.possibleAnlaufstellen.length === 1 && this.model.anlaufstelle === undefined) {
                        this.model.anlaufstelle = this.possibleAnlaufstellen[0];
                    }
                    this.displayAnlaufstellenSelect = this.model.anlaufstelle === undefined;

                });
            }
        }
    }

    public showManuelleAnlaufstellenZuweisungPapier(): boolean {
        return this.model.erfassungsart === TSErfassungsArt.PAPIER
            && this.displayAnlaufstellenSelect
            && (this.model.status === TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE || this.model.status === TSSchadenfallStatus.NEU_PAPIER_FS);
    }

    public getViewTitle(): string {
        return this.dvBernUtil.getViewTitle(this.model);
    }

    private next(): void {
        this.speichernGo('schadenmeldung');
    }

    private beenden(): void {
        this.speichernGo('schadenfaelle');
    }

    public isImportiert(): boolean {
        return !isNullOrUndefined(this.model.schadenfallHerkunft);
    }

    private speichernGo(to: string) {
        to = to || 'schadenmeldung';
        if (this.isGesuchValid() && this.model) {
            this.model.cleanupGesuchsteller();
            this.schadenfallModelManager.saveSchadenfall(this.model).then((response: TSSchadenfall) => {
                if (to === 'schadenmeldung') {
                    this.$state.go(to, {schadenfallId: response.id})
                } else {
                    this.$state.go(to)
                }
            });
        }
    }

    /**
     * Diese Methode prueft ob das Form valid ist. Sollte es nicht valid sein wird das erste fehlende Element gesucht
     * und fokusiert, damit der Benutzer nicht scrollen muss, um den Fehler zu finden.
     * Am Ende wird this.form.$valid zurueckgegeben
     */
    public isGesuchValid(): boolean {
        if (!this.form.$valid) {
            DVBernUtil.focusFirstInvalidInput()
        }
        return this.form.$valid;
    }

    public isInStatusNeu(): boolean {
        return this.model.status === TSSchadenfallStatus.NEU || this.model.status === TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;
    }

    public isSchadenFallNeuOnline() {
        if (this.model) {
            return this.model.status === TSSchadenfallStatus.NEU;   //papier hat neu_papier
        }
        return false;
    }

    private getTSEigentumsverhaeltnisse(): Array<TSEigentumsverhaeltnis> {
        return getTSEigentumsverhaeltnisValuesSchadenfall();
    }

    private changedEigentumsverhaeltinis(): void {
        if (this.model && this.model && this.model.gesuchsteller.eigentumsverhaeltnis) {
            if (this.model.zweitperson !== undefined) {
                switch (this.model.gesuchsteller.eigentumsverhaeltnis) {
                    case TSEigentumsverhaeltnis.GRUNDEIGENTUEMER:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis.PAECHTER;
                        break;
                    case TSEigentumsverhaeltnis.PAECHTER:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis.GRUNDEIGENTUEMER;
                        break;
                    default:
                        this.model.zweitperson.eigentumsverhaeltnis = TSEigentumsverhaeltnis.PAECHTER;
                        break;
                }
            } else {
                console.error('zweitperson should be initialized')
            }
        }
    }

    public displayZweitperson(): boolean {
        return !(this.model.gesuchsteller.eigentumsverhaeltnis === TSEigentumsverhaeltnis.GRUNDEIGENTUEMER_SELBSTBEWIRTSCHAFTER) && this.model.gesuchsteller.rechtsform !== undefined;
    }

    public translateEigentumsverhaeltnisForSelect(etv: TSEigentumsverhaeltnis): string {
        let prefix = eigentumsverhaeltnisPrefix();
        return this.$translate.instant(prefix + TSEigentumsverhaeltnis[etv])
    }
}



// WEBPACK FOOTER //
// ./src/app/gesuch/component/gesuchErstellenView/gesuchErstellenView.ts